import { periods } from "_constants";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import moment from "moment";

import Translate from "utils/translate";
import { fullName } from "utils/user";

const { t } = new Translate();

const dealSort = (deals, key, dir) => {
  const sortKeys = {
    assets: () => (deal) => get(deal, "assets[0].name"),
    budget: () => (deal) => get(deal, "budget.from"),
    channel: () => (deal) => get(deal, "channels[0].company"),
    lastItem: () => (deal) => get(deal, "lastItem.createdAt"),
    location: () => (deal) => get(deal, "location"),
    name: () => (deal) => get(deal, "name"),
    pointPerson:
      () =>
      ({ pointPerson }) =>
        fullName(pointPerson),
    probability: () => (deal) =>
      deal.probability && parseInt(deal.probability.replace("%", ""), 10),
    size: () => (deal) => get(deal, "size.from"),
    spaceCategories: () => (deal) =>
      deal.spaceCategories.length > 0 && t(`spaceCategories.${deal.spaceCategories[0]}`),
    startDate: () => (deal) => deal.startDate && moment(deal.startDate),
    term: () => (deal) => deal.term && deal.term.value / periods[deal.term.period],
    type: () => (deal) => t(`deals.types.${deal.type}`),
  };

  const sortKey = (dir && sortKeys[key] ? sortKeys[key] : sortKeys.lastItem)();

  return orderBy(deals, sortKey, dir ? dir.toLowerCase() : "desc");
};

export default dealSort;
